// Cleaned and optimized version of your AuditLocation component

import React, { useEffect, useState, useMemo, useCallback, ReactNode } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Input,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { showSuccessToast, showErrorToast } from "../../helpers/toast_helper";
import { createSelector } from "reselect";
import classnames from "classnames";

import BreadCrumb from "Components/Common/BreadCrumb";
import Loader from "Components/Common/Loader";
import TableContainer from "./TableContainer";
import type { ThunkDispatch } from "redux-thunk";
import type { AnyAction } from "redux";
import type { RootState } from "store";

import { fetchTicket } from "slices/Ticket/thunk";
import TicketDetailPage from "./TicketDetailPage";
import { exportToExcel } from "helpers/exportToExcel";
import { fetchTicketApi } from "services/ticketService";
import { Link } from "react-router-dom";

const UserRecords = () => {
  const dispatch: ThunkDispatch<RootState, any, AnyAction> = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [activeTab, setActiveTab] = useState("1");
  const [tabStatus, setTabStatus] = useState<string>("");
  const [rowID, setRowId] = useState<string | null>('');

  const selectLayoutState = (state: any) => state;
  const userData = createSelector(selectLayoutState, (state) => ({
    ticketData: state.Ticket.ticketData,
    singleTicketData: state.Ticket.singleTicketData,
    userChangePasswordSuccess: state.ChangePassword.changePwdSuccessMsg,
    userChangePasswordError: state.ChangePassword.changePasswordError,
    loading: state.Ticket.loading,
    pagination: state.Ticket.pagination,
  }));

  const { ticketData, userChangePasswordError, userChangePasswordSuccess, singleTicketData, loading, pagination } = useSelector(userData);

  const UserData = ticketData?.users;
  const singleTicket = singleTicketData?.users?.[0];
  // const CountData = paginationCount;
  const selectLoginState = (state: RootState) => state.Login;

  const selectUserData = createSelector(selectLoginState, (login) => ({
    user: login.user,
    error: login.error,
    useraccessrights: login.useraccessrights
  }));

  const {  useraccessrights } = useSelector(selectUserData);

  const endpoint = window.location.pathname;

  const moduleAccessRights = useraccessrights.accessrights.find(
    (item: { iseditaccess: boolean; path: string, viewonly: string, moduleaccess: string }) => item.path === endpoint
  ) as { path: string; iseditaccess: boolean, viewonly: boolean } | undefined;


  const [filteredUserData, setFilteredUserData] =
    useState<any>([]);

  useEffect(() => {
    setFilteredUserData(UserData || []);
  }, [UserData]);


  // Reset page to 1 when search query changes
  useEffect(() => {
    setPage(1);
  }, [searchQuery]);

  const handleExportTickets = useCallback(async () => {
    try {
      const totalItems = pagination?.total_items || filteredUserData.length || 0;
      const payload = {
        ticket_id: 0,
        activity_description: "",
        ticket_no: "",
        status: tabStatus,
        phone_no: "",
        from_date: "",
        to_date: "",
        priority: 0,
        page: 1,
        page_size: totalItems > 0 ? totalItems : 1000,
      };

      const response = await fetchTicketApi(payload);
      const tickets = response?.data?.users || [];

      if (!tickets.length) {
        showErrorToast("No data available to export!");
        return;
      }

      exportToExcel(tickets, "Tickets_List");
      showSuccessToast("Tickets exported successfully!");
    } catch (error: any) {
      const message =
        error?.message ||
        error?.response?.data?.message ||
        "Failed to export tickets";
      showErrorToast(message);
    }
  }, [filteredUserData.length, pagination?.total_items, tabStatus]);

 useEffect(() => {
  if (!rowID) return;

  const payload = {
    ticket_id: rowID,
    activity_description: "",
    ticket_no: "",
    status: "",
    phone_no: "",
    from_date: "",
    to_date: "",
    priority: 0,
    page:1,
    page_size: limit,
  };

  dispatch(fetchTicket(payload));
}, [rowID, limit, dispatch]);

  // Utility: Convert date to UTC ISO string with optional end-of-day time
  const toUtcISOStringRange = (date: Date, isEnd: boolean = false): string => {
    const offset = date.getTimezoneOffset(); // in minutes
    const utcDate = new Date(date.getTime() - offset * 60000);
    utcDate.setHours(isEnd ? 23 : 0, isEnd ? 59 : 0, isEnd ? 59 : 0, isEnd ? 999 : 0);
    return utcDate.toISOString();
  };

  // useEffect: Show success/error toasts
  useEffect(() => {
    // whenever tab changes, reset page to 1
    setPage(1);
  }, [tabStatus]);

  // Reset page to 1 when search query changes
  useEffect(() => {
    setPage(1);
  }, [searchQuery]);
  useEffect(() => {
    const handler = setTimeout(() => {
      const alteredStatus =
        tabStatus.toLowerCase() === "inactive" ? "Inactive" : tabStatus;
      dispatch(
        fetchTicket(
          {
            "ticket_id": 0,
            "activity_description": "",
            "ticket_no": "",
            "status": tabStatus,
            "phone_no": "",
            "from_date": "",
            "to_date": "",
            "priority": 0,
            "searchkey": searchQuery || "",
            "page": page,
            "page_size": limit
          }

        )
      );
    }, 500);

    return () => clearTimeout(handler); // cleanup 
  }, [searchQuery, page, limit, tabStatus, dispatch]);


  useEffect(() => {

    if (userChangePasswordSuccess) {
      showSuccessToast(userChangePasswordSuccess);
    }
    if (userChangePasswordError) {
      showErrorToast(userChangePasswordError);
    }

  }, [ userChangePasswordSuccess]);






  const handlePageChange = (newPage: number) => setPage(newPage);

  const handleTicketClick = useCallback((id: number) => {

    const payload = {
      "user_id": id,
      "phone_no": "",
      "status": "",
      "from_date": "",
      "to_date": "",
      "priority": 0,
      "search_keyword": "",
      "is_verified": true,
      "page": page,
      "page_size": limit

    }
    dispatch(fetchTicket(payload))


  }, []);





  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    setPage(1);
  };

  const handleValidDate = (date: any) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };
  const handleValidTime = (time: any) => {
    const time1 = new Date(time);
    const getHour = time1.getHours();
    const getMin = time1.getMinutes();
    const getTime = `${getHour}:${getMin}`;
    var meridiem = "";
    if (getHour >= 12) {
      meridiem = "PM";
    } else {
      meridiem = "AM";
    }
    const updateTime =
      moment(getTime, "hh:mm").format("hh:mm") + " " + meridiem;
    return updateTime;
  };




  
  const highlightMatch = (text?: string | JSX.Element, query?: string) => {
    if (!query) return text;
    if (!text) return null;

    const extractText = (element: JSX.Element | string | ReactNode): string => {

      if (typeof element === "string") {
        return element;
      }

      if (React.isValidElement(element)) {
        if (element.props['data-no-highlight']) return "";
        return React.Children.toArray(element.props.children)
          .map((child) => extractText(child))
          .join(" ");
      }


      return "";
    };

    // Extract text content from the JSX element.
    const extractedText = extractText(text);

    // If no extracted text, return as is.
    if (!extractedText) return text;


    const regex = new RegExp(`(${query})`, "gi");
    const parts = extractedText.split(regex);

    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === query.toLowerCase() ? (
            <span key={i} style={{ fontWeight: 600 }}>
              {part}
            </span>
          ) : (
            part
          )
        )}
      </>
    );
  };

  const columns = useMemo(() => {
    const baseColumns = [
           {
        header: "S. No.",
        accessorKey: "ticket_no",
        enableColumnFilter: false,
        cell: (cell: any, index: number) => {
        const serialNumber = (page-1)*limit + cell.row.index + 1
          return serialNumber;
        }
      },
  
      {
        header: "Ticket ID",
        accessorKey: "ticket_no",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const row = cell.row.original;
          const ticketID = (<strong>{row["ticket_no "]}</strong>);
          return highlightMatch(ticketID || "N/A", searchQuery);
        },
      },

      // ✅ Email
      {
        header: "Subject",
        accessorKey: "ticket_subject",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const value = cell.getValue();
          return highlightMatch(value || "N/A", searchQuery);
        },
      },

      // ✅ Phone Number
      {
        header: "Category",
        accessorKey: "category_name",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const row = cell.row.original;
          const dialCode = row.dial_code;
          const value = cell.getValue();
          return highlightMatch(value || "N/A", searchQuery);
        },
      },

      // ✅ Address
      {
        header: "Customer",
        accessorKey: "createdby",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const value = cell.getValue();
          return value ? <>{value}</> : <>N/A</>;
        },
      },

      // ✅ Updated On
      {
        header: <div style={{
          alignItems: "center",
                 width: "95px",
                 padding: "0px 20px",
          }}>
          Status
        </div>,


        accessorKey: "status",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const value = cell.getValue();
          const statusColor = value.toString().toLowerCase() === "new" || value.toString().toLowerCase() === "open" ? "#5374C0" : value.toString().toLowerCase() === "closed" ? "#159E3A" : value.toString().toLowerCase() === "picked" || value.toString().toLowerCase() === "deleted" ? "#A65F00" : "";

          const statusButton = (
            <div
              style={{
                border: `1px solid ${statusColor}`,
                borderRadius: "20px",
                color: statusColor,
                padding: "4px 20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "95px",
                height: "26px",
                font: "12px",

              }}
            >
              {value.toString().toLowerCase() === "closed"? "Solved":value}
            </div>
          );

          return statusButton
         
        },
      },
      {
        header: "Time",
        accessorKey: "createdon",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const value = cell.getValue();
          return value ? (
            <>
              {/* {handleValidDate(value)},{" "} */}
              <small className="text-muted">{handleValidTime(value)}</small>
            </>
          ) : (
            <>N/A</>
          );
        },
      },
      {
        header: "Date",
        accessorKey: "createdon",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const value = cell.getValue();
          return value ? (
            <>
              {handleValidDate(value)}
      
            </>
          ) : (
            <>N/A</>
          );
        },
      },
      {
        header: "Feedback",
        accessorKey: "feedback",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const value = cell.getValue();
          return highlightMatch(value || "N/A", searchQuery);
        },
      },


    ];


    // ✅ Common columns
    const commonColumns: any[] = [];


    return [...baseColumns, ...commonColumns];
  }, [activeTab, handleTicketClick, tabStatus, page, limit]);

  document.title = "IT Ticketing Admin Report";
  
  const toggleTab = (tab: any, type: "all" | "Open" | "Picked" | "Closed") => {
    if (activeTab !== tab) {
      setActiveTab(tab);

      let filteredTeamMembers = UserData;

      if (type === "Open") {
        setTabStatus("Open");

      } else if (type === "Picked") {
        setTabStatus("Picked");

      }  else if (type === "Closed") {
        setTabStatus("Closed");

      }else if (type === "all") {
        // setShowAssign(true);
        setTabStatus("");
      }

      setPage(1)
      setFilteredUserData(filteredTeamMembers);
    }
  };

  const handleOpenLeadDetails = useCallback((guid: string) => {
    setRowId(guid);
  }, []);

 const handleBackToList = useCallback(() => {
  setRowId(null);  // show list again

  // ✅ CALL LIST API AGAIN WITH CURRENT PAGE + LIMIT
  dispatch(fetchTicket({
    ticket_id: 0,
    activity_description: "",
    ticket_no: "",
    status: tabStatus,
    phone_no: "",
    from_date: "",
    to_date: "",
    priority: 0,
    page: page,        
    page_size: limit    
  }));
}, [dispatch, page, limit, tabStatus]);

  // If a lead is selected, show lead details
  if (rowID) {


    return (
      <div className="page-content">
        <Container fluid>
          <TicketDetailPage id={rowID} singleTicketData={singleTicket} onBack={handleBackToList} loading={loading} />
        </Container>
      </div>
    );
  }
  return (
    <React.Fragment>
      {/* <ToastContainer autoClose={3000} limit={1} /> */}
      <div className="page-content">
        <Container fluid className="border pt-4 rounded-4 bg-light mb-3 ms-3 pe-4">
          <BreadCrumb title="Tickets" pageTitle={["Report", "Ticket"]} />


          <Row className="align-items-center g-3 d-flex justify-content-between pb-4 pe-3">
          <Col md={2}>
            <div className="position-relative">
              <Input
                type="text"
                className="form-control border ps-5 ms-2 rounded-3"
                value={""}
                placeholder="Filter"
                disabled
              />
              <i
                className="ri-filter-line position-absolute top-50 start-0 translate-middle-y text-muted ms-3"
                style={{ fontSize: "1.1rem" }}
              />
            </div>
          </Col>
          <Col md={3}>
            <div className="position-relative">
              <Input
                type="text"
                className="form-control border ps-5 ms-2 rounded-3"
                value={searchQuery}
                placeholder="Search tickets..."
                onChange={handleSearchInputChange}
              />
              <i
                className="ri-search-line position-absolute top-50 start-0 translate-middle-y text-muted ms-3"
                style={{ fontSize: "1.1rem" }}
              />
            </div>
          </Col>
          <Col
            md={7}
            className="text-end d-flex justify-content-end gap-2 align-items-center"
          >
            <Button color="primary" outline tag={Link} to="/ticketcategory">
               <i className="ri-database-2-fill align-middle me-1"></i>
               Ticket Category
            </Button>
              <button
                className="btn btn-success"
                onClick={handleExportTickets}
              >
                <i className="ri-file-excel-2-line me-2"></i>
                Export Excel
              </button>
           </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card id="leadsList" className="border-0 shadow-none" style={{ border: "none" }}>
                <CardHeader className="border">
                  <Row className="g-4 align-items-center" >
                    
                    <Col>
                      <Nav
                        className="nav-tabs-custom card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "1" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("1", "all");
                            }}
                            href="#"
                          >
                            All
                            {/* <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {CountData?.total_items || "0"}
                            </span> */}
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "2" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("2", "Open");
                            }}
                            href="#"
                          >
                            Open         
                                               {/* <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {CountData?.total_open || "0"}
                            </span> */}
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "3" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("3", "Picked");
                            }}
                            href="#"
                          >
                            Picked                 
                                       {/* <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {CountData?.total_picked || "0"}
                            </span> */}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "4" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("4", "Closed");
                            }}
                            href="#"
                          >
                            Solved                         
                               {/* <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {CountData?.total_closed || "0"}
                            </span> */}
                          </NavLink>
                        </NavItem>
                       
                      </Nav>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="pt-3" style={{ minHeight: "500px" }}>
                  <div className="tab-content">
                    {!loading ? (
                      filteredUserData?.length > 0 ? (
                        <TableContainer
                          columns={columns}
                          data={filteredUserData || []}
                          isGlobalFilter={false}
                          customPageSize={limit}
                          pagination={pagination}
                          divClass="table-responsive table-card"
                          tableClass="align-middle border-bottom rounded-pill"
                          theadClass="bg-primary text-white"
                          setLimit={setLimit}
                          setPage={setPage}
                          limit={limit}
                          onPageChange={handlePageChange}
                          setRowId={setRowId}
                          onRowClick={handleOpenLeadDetails}
                        // SearchPlaceholder={searchQuery}  
                        />
                      ) : (
                        <div className="text-center p-4">No records found.</div>
                      )
                    ) : (
                      <Loader />
                    )}
                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>


    </React.Fragment>
  );
};

export default UserRecords;
